"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceSubscriptionHandler = replaceSubscriptionHandler;
var ReplaceSubscriptionFailed = _interopRequireWildcard(require("@ori-events/replace-subscription-failed"));
var _api = require("../api");
var _logger = require("../logger");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function replaceSubscriptionHandler({
  detail: {
    droppingId,
    itemCode,
    subscriptionId
  }
}, {
  client,
  customerId,
  tenant
}) {
  // STEP 1 - Update through API
  const subscriptionItemId = 0;
  const item = {
    droppingId,
    isReplacementAllowed: true,
    itemCode,
    quantity: 1,
    subscriptionItemId
    // TODO -- This was optional / not used before, that's why the cast for now.
    // The ReplaceSubscription event data contains currently only the props destructured above.
    // To change it (if requested), we need cross-team collaboration with Presentation.
    // discountedPrice: 0,
    // discountPercent: 0,
    // totalBp: 0,
    // price: 0,
    // isDropped: false,
  };
  const globalCustomersSubscriptionItemDto = item;
  try {
    await (0, _api.replaceSubscription)({
      client,
      customerId,
      globalCustomersSubscriptionItemDto,
      subscriptionId,
      subscriptionItemId,
      tenant
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while replacing subscription in replaceSubscription event.'
    });
    return false;
  }

  // STEP 2 - Update shopping context via Online endpoint
  const data = await (0, _api.fetchShoppingContextData)();
  if (ReplaceSubscriptionFailed.isReplaceSubscriptionErrorResponse(data)) {
    const errorEvent = new CustomEvent(ReplaceSubscriptionFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
